import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import 'leaflet/dist/leaflet.css';
render(<App data-id="element-272" />, document.getElementById('root'));